export enum ModalDismissReasons {
  BACKDROP_CLICK,
  ESC,
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/slide-in-modal/types/modal-dismiss-reasons.ts